import script from "./ApiTokens.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiTokens.vue?vue&type=script&setup=true&lang=js"

import "./ApiTokens.vue?vue&type=style&index=0&id=ee2043ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee2043ac"]])

export default __exports__